import { TApplicationState } from '../../types/redux';

export function getSuggestApiKey(state: TApplicationState) {
  return state.common.suggestApiKey;
}
